import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('divider'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Divider'),
    data: function data() {
        return {};
    },
    props: {
        dashed: Boolean,
        hairline: {
            type: Boolean,
            default: true
        },
        contentPosition: {
            type: String,
            default: 'center'
        },
        borderWidth: {
            type: Number,
            default: 40
        },
        borderColor: {
            type: String,
            default: '#ebedf0'
        },
        isFlex: {
            type: Boolean,
            default: false
        },
        borderMargin: {
            type: Number,
            default: 16
        }
    },
    render: function render() {
        var h = arguments[0];
        var props = this.$props,
            slots = this.$slots;
        var boderStyle = {
            width: ''.concat(this.borderWidth, 'px'),
            flex: this.isFlex || this.contentPosition !== 'center' ? '1' : '',
            transform: this.hairline ? 'scaleY(0.5)' : '',
            borderStyle: this.dashed ? 'dashed' : ''
        };
        var marginRight = {
            marginRight: ''.concat(this.borderMargin, 'px')
        };
        var marginLeft = {
            marginLeft: ''.concat(this.borderMargin, 'px')
        };
        var boxStyle = {
            justifyContent: this.contentPosition == 'center' ? 'center' : '',
            borderColor: this.borderColor
        };
        return h(
            'div',
            {
                class: b(
                    _defineProperty(
                        {
                            dashed: props.dashed,
                            hairline: props.hairline
                        },
                        'content-'.concat(props.contentPosition),
                        slots.default
                    )
                ),
                attrs: {
                    role: 'separator'
                },
                style: boxStyle
            },
            [
                h('div', {
                    class: b('border'),
                    style: Object.assign(Object.assign({}, boderStyle), marginRight)
                }),
                slots.default,
                h('div', {
                    class: b('border'),
                    style: Object.assign(Object.assign({}, boderStyle), marginLeft)
                })
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
